/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamRunStateResponseData } from './genericApiResponseOralExamRunStateResponseData';
import type { GenericApiResponseOralExamRunStateResponseMessage } from './genericApiResponseOralExamRunStateResponseMessage';
import type { GenericApiResponseOralExamRunStateResponsePagination } from './genericApiResponseOralExamRunStateResponsePagination';
import type { GenericApiResponseOralExamRunStateResponseError } from './genericApiResponseOralExamRunStateResponseError';

export interface GenericApiResponseOralExamRunStateResponse {
  data?: GenericApiResponseOralExamRunStateResponseData;
  message?: GenericApiResponseOralExamRunStateResponseMessage;
  pagination?: GenericApiResponseOralExamRunStateResponsePagination;
  error?: GenericApiResponseOralExamRunStateResponseError;
  statusCode?: number;
}
